import React, { useEffect, useState } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import ResponsiveModal from '../ui/ResponsiveModal';

const QualitySimpleItemModal = ({
  isOpen,
  onClose,
  onSave,
  title,
  fieldLabel,
  initialValue = '',
}) => {
  const [value, setValue] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!isOpen) {
      document.body.style.overflow = 'unset';
      return;
    }
    document.body.style.overflow = 'hidden';
    setValue(initialValue || '');
    setError('');
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, initialValue]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!value.trim()) {
      setError(`${fieldLabel} alanı zorunludur.`);
      return;
    }
    await onSave(value.trim());
  };

  return (
    <ResponsiveModal isOpen={isOpen} onClose={onClose} className="max-w-lg">
      <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 dark:border-gray-700">
        <h2 className="text-lg font-semibold text-gray-900 dark:text-white">{title}</h2>
        <button type="button" onClick={onClose} className="text-gray-500 hover:text-gray-700 dark:hover:text-gray-300">
          <XMarkIcon className="w-5 h-5" />
        </button>
      </div>

      <form onSubmit={handleSubmit} className="p-6 space-y-4">
        {error && <div className="text-sm text-red-600 dark:text-red-400">{error}</div>}
        <input
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder={fieldLabel}
          className="w-full border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 bg-transparent text-gray-900 dark:text-gray-100 placeholder:font-semibold placeholder:text-gray-400 dark:placeholder:text-gray-500"
        />
        <div className="flex justify-end gap-3">
          <button type="button" onClick={onClose} className="px-4 py-2 rounded-md border border-gray-300 dark:border-gray-600 text-sm text-gray-700 dark:text-gray-200">
            İptal
          </button>
          <button type="submit" className="px-4 py-2 rounded-md bg-blue-600 text-white text-sm">
            Kaydet
          </button>
        </div>
      </form>
    </ResponsiveModal>
  );
};

export default QualitySimpleItemModal;
